import React, { useEffect, useState } from 'react';
import { Transition, config, animated } from 'react-spring';
import { Message } from '@tomis-tech/types';

import { useParent } from '../context';
import ChatWindowInner from './ChatWindowInner';

const inStyles = {
  opacity: 1,
  transform: 'translate(0%, 0px) rotate3d(0, 1, 0, 0deg)',
};
const getOutStyles = (isMobile: boolean) => ({
  opacity: 0,
  transform: isMobile
    ? 'translate(0%, 10px) rotate3d(0,1,0,0deg)'
    : 'translate(30%, 0px) rotate3d(0,1,0,-10deg)',
});

type Props = {
  isOpen: boolean;
  messages: Message[];
  settlePosition: () => void;
};
const ChatWindow = React.memo(({ isOpen, messages, settlePosition }: Props) => {
  const { isMobile } = useParent();
  const [outStyles, setOutStyles] = useState(getOutStyles(isMobile));
  useEffect(() => {
    setOutStyles(getOutStyles(isMobile));
  }, [isMobile]);

  return (
    <Transition
      native
      config={config.stiff}
      items={isOpen}
      update={{ isMobile }}
      from={outStyles}
      enter={inStyles}
      leave={outStyles}
      onRest={settlePosition}
    >
      {show =>
        show &&
        (containerStyle => (
          <animated.div
            style={containerStyle}
            css={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              display: 'block',
              flexDirection: 'column',
              transformOrigin: '120% 50%',
            }}
          >
            <ChatWindowInner close={close} messages={messages} />
          </animated.div>
        ))
      }
    </Transition>
  );
});

export default ChatWindow;
